import MinusIcon from './Cutsies/MinusIcon';
import PlusIcon from './Cutsies/PlusIcon';

interface PlusMinusButtonProps {
  onClick: () => void;
  which: 'plus' | 'minus';
  'data-intercom-target'?: string;
}

function PlusMinusButton({
  onClick,
  which,
  'data-intercom-target': intercomTarget,
}: PlusMinusButtonProps) {
  return (
    <button
      className="w-8 h-8 text-teal-600 flex items-center justify-center hover:text-teal-600 transition-colors"
      onClick={onClick}
      aria-label={which === 'plus' ? 'Add item' : 'Remove item'}
      data-intercom-target={intercomTarget}
    >
      {which === 'plus' ? <PlusIcon /> : <MinusIcon />}
    </button>
  );
}

export default PlusMinusButton;
